import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LabelInterface } from '../label/label.interface';
import { LabelTemplateInterface } from '../label/labelTemplate.interface';
import { LabelService } from '../services';

@Component({
  selector: 'app-label-preview',
  templateUrl: './label-preview.component.html',
  styleUrls: ['./label-preview.component.scss']
})
export class LabelPreviewComponent implements OnInit, OnDestroy {

  @Input() label: LabelInterface;
  @Input() layout: 'row' | 'column' | 'row-reverse' | 'column-reverse' = 'column';

  public loading = false;

  public labelTemplates: LabelTemplateInterface[] = [];
  public labelPreviewSvg: string = '';

  private subscriptions = new Subscription();

  constructor(public labelService: LabelService) { }

  ngOnInit() {
    this.labelTemplates = this.labelService.getLabelTemplates();
    // this.drawLabel();

    this.subscriptions.add(this.labelService.templatesChanged.subscribe(
      (data) => {
        this.labelTemplates = data;
      },
      (err) => {},
      () => {}
    ));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  formatDate(): string {
    return (this.label.date.getMonth() + 1).toString().padStart(2, '0') + '.' + this.label.date.getFullYear().toString();
  }

  getLabelTemplate(): string {
    const ltemp = this.labelTemplates.find((el) => {
      return el.name === this.labelService.currentLabelType;
    });
    if (ltemp === undefined) {
      return '';
    }
    return ltemp.svg;
  }

  generatePreview() {
    let svg = this.getLabelTemplate().repeat(1);
    svg = svg.replace(/{{id}}/g, this.label.id.toString().padStart(5, '0'));
    svg = svg.replace(/{{organisation1}}/g, 'MBG');
    svg = svg.replace(/{{organisation2}}/g, 'Espelkamp');
    svg = svg.replace(/{{place}}/g, this.label.place);
    svg = svg.replace(/{{date}}/g, this.formatDate());
    svg = svg.replace(/{{info}}/g, this.label.info);
    svg = svg.replace(/{{info1}}/g, this.label.info);
    svg = svg.replace(/{{info2}}/g, this.label.info);
    return svg;
  }

  printLabel() {
    this.loading = true;
    this.labelService.printLabel(this.label).subscribe(
      (data) => {},
      (err) => {},
      () => {
        this.loading = false;
      }
    );
  }


}
